<template xmlns="http://www.w3.org/1999/html">
  <div class="form-group">
    <table class="table">
      <tbody>
      <tr>
        <td>フリーワード</td>
        <td><input type="keyword" class="form-control input-sm" v-model="params.mail"></td>
      </tr>

      </tbody>
    </table>
    <div class="form-group">
      <div class="col-xs-12">
        <button class="btn btn-block btn-primary" v-on:click="search">検索</button>
      </div>
    </div>
  </div>
</template>

<script>
  // import Api from '../../service/Api.vue'

  export default {
    data () {
      return {
        params: {
          keyword: ''
        }
      }
    },
    created: function () {
      this.$emit('clickSearch', this.params)
    },
    methods: {
      search: function () {
        this.$emit('clickSearch', this.params)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Search.vue?3bd49088